export default __webpack_public_path__ + "15d29c2a08a71bb3323716524acff700.png";